// eslint-disable-next-line
import { s_gi } from "./adobeSDK"
export const adobe = (trackData) => {
    const _trackData = {
        program: 'WechatAccountTraining', //process.env.PROGRAM,
        pageName: '',
        aid: '',
        suitid: process.env.SUITID,
        prePageName: '',
        isAction: true,
        actionName: ''
    }
    trackData = {..._trackData, ...trackData}
    const s = new s_gi('dgcl-wechat-accounts-prod')
    s.trackingServer = 'daimlergreaterchinaltd.sc.adobedc.cn' //process.env.AASERVER
    if (trackData.aid != '') {
        s.analyticsVisitorID = trackData.aid
        s.contextData['vid'] = trackData.aid
    }
    s.contextData['miniProgram'] = trackData.program
    if (trackData.actionName) {
        s.contextData['linkNameDesc'] = `${trackData.program}_${trackData.actionName}`
    }
    if (trackData.pageName) {
        s.contextData['page_name'] = `${trackData.program}_${trackData.pageName}`
    }
    if (trackData.isAction) {
        s.tl(s, "o", `${trackData.program}_${trackData.actionName}`)
    } else {
        if (trackData.prePageName) {
            s.contextData['prePageName'] = `${trackData.program}_${trackData.prePageName}`
        }
        s.contextData['url'] = window.location.href
        if (trackData.pageName) {
            s.pageName = `${trackData.program}_${trackData.pageName}`
        }
        s.t()
    }
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const tracking = (trackData) => {
    // adobe(trackData)
};